<template>
    <div class="dataBox">
        <div class="baseTitle">文物信息</div>
        <div class="baseBox">
            <div class="baseLeft" style="margin-right: 20px;">
                <div class="baseData">
                    <div class="baseDataText">
                        文物名称：{{ relic?relic.name:'-' }}<br/>
                        材质：{{ relic?relic.relicTexture.name:'-' }}<br/>
                        年代：{{ relic?relic.relicEra.name:'-' }}<br/>
                        级别：{{ relic?relic.relicLevel.name:'-' }}<br/>
                    </div>
                    <div class="baseDataImg" ref="container">
                        <el-carousel :interval="4000" :autoplay="false" v-if="relicPhotoList.length>0" indicator-position="none" height="100%">
                            <el-carousel-item v-for="(item, index) in relicPhotoList" class="cssCarousel" :key="index">
                                <el-image style="width: 100%; height: 100%" :src="item" fit="contain" />
                            </el-carousel-item>
                        </el-carousel>
                        <div class="empty" v-else>
                            暂无图片
                        </div>
                    </div>
                </div>
                <div class="chartBox">
                    
                    <div class="title">
                        文物历史数据
                        <el-select v-model="hisLocationId" @change="changeHis" class="selectCss" placeholder="请选择位置点">
                            <el-option
                            v-for="item in options"
                            :key="item.locationId"
                            :label="item.locationName"
                            :value="item.locationId"
                            />
                        </el-select>
                    </div>
                    <div class="chart">
                        <baseChart v-if="chartData.length>0" :data="chartData"/>
                    </div>
                </div>
            </div>
            <div class="baseRight">
                <div class="rightTop">
                    <div class="RT-title">
                        环境实时数据
                        <el-select v-model="rtLocationId" @change="changeRT" class="selectCss" placeholder="请选择位置点">
                            <el-option
                            v-for="item in optionsRT"
                            :key="item.locationId"
                            :label="item.locationName"
                            :value="item.locationId"
                            />
                        </el-select>
                    </div>
                    <div class="mainBox">
                        <div class="rtBox" v-if="currentSeners.length>0">
                            <div class="mainItme" v-for="(item, index) in currentSeners" :key="index">
                                <img class="iconTips" :src="item.img">
                                <div class="msgTips">
                                    <div><span class="count" :style="`color:${item.color}`">{{ item.num }}</span>{{ item.unit }}</div>
                                    <div class="name">{{ item.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="empty" v-else>
                            暂无数据
                        </div>
                    </div>
                </div>
                <div class="rightCenter">
                    <div class="RT-title">
                        本体含水率
                        <el-select v-model="waterId" @change="changeWater" class="selectCss" placeholder="请选择位置点">
                            <el-option
                            v-for="item in moistureChartDataList"
                            :key="item.locationId"
                            :label="item.name"
                            :value="item.locationId"
                            />
                        </el-select>
                    </div>
                    <div class="mainBox">
                        <lineChart v-if="waterLine.length>0" :series="waterLine" name="含水率（%）"/>
                        <div v-else class="empty">
                            暂无数据
                        </div>
                    </div>
                </div>
                <div class="rightCenter">
                    <div class="RT-title">
                        本体裂隙
                    </div>
                    <div class="mainBox">
                        <div class="lixiImg">
                            <el-image
                            v-if="LXimg"
                            style="width: 100%; height: 100%"
                            :src="LXimg"
                            :preview-src-list="[LXimg]"
                            fit="contain"
                            />
                        </div>
                        <div class="lixiChart">
                            <lineChart :series="seriesLX" v-if="seriesLX.length>0"/>
                            <div v-else class="empty">
                                暂无数据
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { relicSensorData } from '@/api/relic.js'
import baseChart from '@/components/chart/baseChart.vue'
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js';
import lineChart from './lineChart.vue'
export default{
    components:{
        baseChart,
        lineChart
    },
    data(){
        return{
            relicId:'relic_37010201000001',
            chartData:[],
            relicPhotoList:[],
            relic:null,
            options:[],
            hisLocationId:null,
            optionsRT:[],
            rtLocationId:null,
            seriesLX:[],
            LXimg:null,
            listSeners:[
                {name:'温度', sensorPhysicalid:33, img:require('../../assets/img/s-wd.png'), num:26, unit:'℃',color:'#FD1410'},
                {name:'温度', sensorPhysicalid:2078, img:require('../../assets/img/s-wd.png'), num:26, unit:'℃',color:'#FD1410'},
                {name:'湿度', sensorPhysicalid:32, img:require('../../assets/img/s-sd.png'), num:36, unit:'%RH',color:'#7DB1F9'},
                {name:'湿度', sensorPhysicalid:2077, img:require('../../assets/img/s-sd.png'), num:36, unit:'%RH',color:'#7DB1F9'},
                {name:'光照', sensorPhysicalid:41, img:require('../../assets/img/s-gz.png'), num:6189.32, unit:'lx',color:'#FFD310'},
                {name:'光照', sensorPhysicalid:2083, img:require('../../assets/img/s-gz.png'), num:6189.32, unit:'lx',color:'#FFD310'},
                {name:'紫外', sensorPhysicalid:42, img:require('../../assets/img/s-zw.png'), num:0, unit:'uw/cm²',color:'#A95CC8'},
                {name:'二氧化碳', sensorPhysicalid:36, img:require('../../assets/img/s-co2.png'), num:952, unit:'ppm',color:'#40F969'},
                {name:'VOC', sensorPhysicalid:1, img:require('../../assets/img/s-voc.png'), num:568, unit:'ppb',color:'#40F969'},
                {name:'露点', sensorPhysicalid:43, img:require('../../assets/img/s-ld.png'), num:568, unit:'℃',color:'#3FDEB3'},
                {name:'含水率', sensorPhysicalid:3078, img:require('../../assets/img/s-hsl.png'), num:568, unit:'%',color:'#26CFF6'},
            ],
            currentSeners:[],
            moistureChartDataList:[],
            waterId:null,
            waterLine:[]
        }
    },
    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('id')){
            this.relicId = urlParams.get('id');
        }
        this.GetData()
    },
    methods:{
        changeHis(val){
            this.chartData = []
            this.hisLocationId = val
            let data = this.options.find(i=>{
                return i.locationId == val
            }).chartList
            setTimeout(()=>{
                this.chartData = data.map(el=>{
                    let obj = {
                        name: el.name,
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        data: el.data
                    }
                    return obj
                })
            },100)
        },
        changeRT(val){
            this.rtLocationId = val
            let data = this.optionsRT.find(i=>{
                return i.locationId == val
            }).locationSensorInfoMap
            let current = this.listSeners.map(el=>{
                let obj = el
                if(data[el.sensorPhysicalid]){
                    obj['flag'] = true
                    obj['unit'] = data[el.sensorPhysicalid].units
                    obj['num'] = data[el.sensorPhysicalid].sensorPhysicalValue
                }else{
                    obj['flag'] = false
                }
                return obj
            })
            this.currentSeners = current.filter(i=>{
                return i.flag == true
            })
        },
        changeWater(val){
            this.waterId = val
            let datas = this.moistureChartDataList.find(i=>{
                return i.locationId == val
            })
            this.waterLine = [
                {
                    name: datas.name,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    data: datas.data
                }
            ]
        },
        GetData(){
            relicSensorData(this.relicId).then(r=>{
                this.relic = r.data.relic.relic
                this.options = r.data.chartData
                if(r.data.fractureHistoryData){
                    let fractureHistoryData = r.data.fractureHistoryData
                    this.seriesLX = [{
                        name:'裂隙变化幅度',
                        data: fractureHistoryData.map(i=>{
                            return [i.date, i.length]
                        }),
                        type: 'line',
                        symbol: 'none',
                        areaStyle: {
                            color:{
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgb(255, 158, 68)' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgb(255, 70, 131)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                        itemStyle:{
                            color:'rgb(255, 70, 131)', 
                        }
                    }]
                }
                if(r.data.fractureRealtimeData){
                    this.LXimg = r.data.fractureRealtimeData.pic
                } 
               
                if(this.options.length>0){
                    this.changeHis(this.options[0].locationId)
                }
                this.optionsRT = r.data.relicRealtimeData.realtimeData
                if(this.optionsRT.length>0){
                    this.changeRT(this.optionsRT[0].locationId)
                }
                //let deployCoordinates = r.data.relic.deployCoordinates
                // if(deployCoordinates){
                //     this.initMode(deployCoordinates.model)
                // }
                this.relicPhotoList = r.data.relic.relic.relicPhotoList.map(img=>{
                    return img.path
                })
                   

                this.moistureChartDataList = r.data.moistureChartDataList
                if(this.moistureChartDataList.length>0){
                    this.changeWater(this.moistureChartDataList[0].locationId)
                }
                

            })
        },
        initMode(mode){
            let dom = this.$refs.container
            var width = dom.clientWidth; //窗口宽度
            var height = dom.clientHeight; //窗口高度
            var k = width / height; //窗口宽高比

            let renderer = new THREE.WebGLRenderer({ antialias:true, alpha: true, physicallyCorrectLights:true })
            renderer.setPixelRatio( window.devicePixelRatio )
            renderer.setSize(width, height)
            dom.appendChild( renderer.domElement )

            let scene = new THREE.Scene()

            var s = 100; //三维场景显示范围控制系数，系数越大，显示的范围越大
            let camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 1500);
            camera.position.set(400, 300, 500); //设置相机位置
            camera.lookAt(new THREE.Vector3(0, 0, 0)); //坐标原点

            // 平行光1
            var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.5);
            directionalLight.position.set(300, 100, 200);
            scene.add(directionalLight);

            //环境光1
            var ambient = new THREE.AmbientLight(0xffffff,0.5);
            scene.add(ambient);

            let controls = new OrbitControls( camera, renderer.domElement );
            controls.update();

            let loader = new OBJLoader()
            loader.load(`${window.g.ServerPath}/model/${mode.baseUrl}${mode.objName}`,mesh=>{
                // 创建一个纹理加载器
                var textureLoader = new THREE.TextureLoader();
                
                // 加载颜色纹理
                var texture = textureLoader.load(`${window.g.ServerPath}/model/${mode.baseUrl}${mode.textureName}`);
                texture.needsUpdate = true;
                let materials = new THREE.MeshLambertMaterial({
                    map: texture,
                })
                mesh.traverse(child => {
                    if (child instanceof THREE.Mesh) {
                        child.material.side = THREE.DoubleSide;
                        child.material = materials;
                    }
                });
                scene.add(mesh);
                // 包围盒计算模型对象的大小和位置
                var box3 = new THREE.Box3();
                box3.expandByObject(mesh); // 计算模型包围盒
                var size = new THREE.Vector3();
                box3.getSize(size); // 计算包围盒尺寸
                var center = new THREE.Vector3();
                box3.getCenter(center); // 计算一个层级模型对应包围盒的几何体中心坐标


                // 计算包围盒的最大边长
                function maxSize(vec3) {
                    var max;
                    if (vec3.x > vec3.y) {
                        max = vec3.x
                    } else {
                        max = vec3.y
                    }
                    if (max > vec3.z) {} else {
                        max = vec3.z
                    }
                    return max;
                }

                var max = maxSize(size); //包围盒长宽高中最大的一个值，用来表征模型的尺寸
                // 1.相机位于模型包围盒之外  算法：模型世界坐标三个分量分别+1.5倍max       
                camera.position.copy(center.clone().addScalar(max * 1.5));
                // 2. 居中渲染：设置相机目标观察点，指向包围盒几何中心
                camera.lookAt(center);
                // 3.全屏渲染：渲染范围和模型尺寸相近 模型尺寸用长宽高其中最大值表征
                s = max/2;//如果全屏渲染s是max 2倍左右
                camera.left = -s * k;
                camera.right = s * k;
                camera.top = s;
                camera.bottom = -s;
                camera.near = max*0.1;//最好和相机位置或者说包围盒关联，别设置0.1 1之类看似小的值
                camera.far = max * 4;//根据相机位置和包围大小设置，把包围盒包含进去即可，宁可把偏大，不可偏小
                camera.updateProjectionMatrix();//渲染范围改变，注意更新投影矩阵
            })
            function animate() {
                requestAnimationFrame( animate );
                renderer.render( scene, camera );
            }
            animate()
        }
    }
}
</script>
<style lang="scss" scoped>
    .dataBox{
        width: 100%;
        min-height: 100%; 
        background-color: #000224;
        color: white;
    }
    .baseTitle{
        width: 100%;
        background-image: url('../../assets/pageImg/titleLine.png');
        background-size: 100% 50%;
        background-position: 50% 80%;
        background-repeat: no-repeat;
        line-height: 30px;
        height: 50px;
    }
    .title{
        height: 30px;
        font-size: 16px;
        font-weight: bold;
        color: white;
        position: relative;
        .selectCss{
            position: absolute;
            bottom: -10px;
            right: 10px;
            width: 200px;
            height: 30px;
        }
    }
    .baseBox{
        width: 100%;
        height: 900px;
        display: flex;
        justify-content: space-between;
        .baseLeft{
            width: calc(100% - 450px);
            height: 100%;
            .baseData{
                width: 100%;
                height: 430px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                .baseDataText{
                    line-height: 30px; 
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    z-index: 10;
                }
                .baseDataImg{
                    width: 100%;
                    height: 100%;
                }
            }
            .chartBox{
                margin-top: 20px;
                padding: 10px 20px;
                width: 100%;;
                height: calc(100% - 450px);
                box-sizing: border-box;
                background-image: url('../../assets/pageImg/relic-bglong.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                .chart{
                    width: 100%;
                    height:calc(100% - 30px);
                }
            }
        }
        .baseRight{
            width: 430px;
            height:100%;
            .RT-title{
                height: 30px;
                position: relative;
                .selectCss{
                    position: absolute;
                    bottom: -10px;
                    right: 10px;
                    width: 200px;
                    height: 30px;
                }
            }
            .mainBox{
                width: 100%;
                height: calc(100% - 30px);
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
            }
            .rtBox{
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
            }
            .rightTop{
                width: 100%;
                height: 32%;
                background-image: url('../../assets/pageImg/relic-bgshort.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 10px 20px;
                box-sizing: border-box;
                .mainItme{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 50%;
                    .iconTips{
                        width: 40px;
                        height: 50px;
                        object-fit: contain;
                    }
                    .msgTips{
                        font-size: 14px;
                        color: #D0DFE3;
                        width: calc(100% - 50px);
                        .count{
                            font-size: 20px;
                            font-weight: bold;
                        }
                    }
                }
            }
            .rightCenter{
                width: 100%;
                height: calc(34% - 10px);
                background-image: url('../../assets/pageImg/relic-bgshort.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 10px 20px;
                box-sizing: border-box;
                margin-top: 10px;
                .lixiImg{
                    width: 100%;
                    height: 35%;
                }
                .lixiChart{
                    width: 100%;
                    height: 65%;
                }
            }
        }
    }
    
    /deep/.el-input__wrapper{
        background-color:#00022400;
        box-shadow: 0 0 0 1px #2a5acb inset;
    }
    /deep/.el-carousel--horizontal{
        height: 100%;
    }  
    /deep/.cssCarousel{
        display: flex;
        justify-content: center;
        background-color: #000224;
    }
    
   .empty{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(184, 184, 184);
   }
    
    
  
</style>